import { AxiosError } from "axios";
import { getNotificationStyle } from "../common/notification";
import { IFileUpload, IFilter } from "../model/CommonModel";
import {
    IBillTypeUpdate,
    IChangeDeliveryDate, IClearCity, IDriverRequest, IManifestationRequest, IPieceBarcodeRequest, IPodResponse, IReCalculateRequest, IUpdateManifest,
    IVolumetric, INorDelivery,
    IAddHoldAtTerminalRequest,
    IUpdatePickUpDetails,
    IBulkHoldManifestRequest,
    IBulkInvoiceRequest,
    IValidAgreementDetailRequest,
    IUpdateCodRequest,
    FileUploadRequest,
    IAdhocTripsRequest
} from '../model/OperationModel';
import { IFleetManPower, IReWeight } from './../model/OperationModel';
import { MultiUploadCostModuleFileData, MultiUploadPodFileData, UploadCnDnFileData, UploadPodFileData } from './../stores/common';
import AjexPortalService from "./api";
import config from './config';
import { RcFile } from "antd/lib/upload";

const commonURL = process.env.REACT_APP_TMS_COMMON_SERVICE;
const ENQUIRY_QUOTATION_URL = process.env.REACT_APP_TMS_ENQUIRY_QUOTATION_SERVICE;
const FILE_SERVICE_URL = process.env.REACT_APP_TMS_FILE_SERVICE;

const MANUAL_WAYBILL_URL = process.env.REACT_APP_TMS_MANUAL_WAYBILL_SERVICE;
const ADHOC_URL = process.env.REACT_APP_TMS_ADHOC_SERVICE;

const configuration = {
    headers: {
        'Content-Type': 'multipart/form-data',
    }
};

const fleetManPower = config.get('fleetManPower');
const createFleet = config.get('create');
const operation = config.get('operation');
const employee = config.get('employee');
const position = config.get('position');
const code = config.get('code');
const assign = config.get('assign');
const assignDelivery = config.get('assignDelivery');
const bookingOperationDetail = config.get('bookingOperationDetail');
const wayBill = config.get('wayBill');
const rto = config.get('rto');
const pickup = config.get('pickup');
const getPieceBarCodes = config.get('getPieceBarCodes');
const getBarCodes = config.get('getBarCodes');
const getVolumeMetricWeight = config.get('getVolumeMetricWeight');
const scanAtHub = config.get('scanAtHub');
const podCollection = config.get('podCollection');
const manifest = config.get('manifest');
const reCalculate = config.get('reCalculate');
const wayBillNo = config.get('wayBillNo');
const submitForInvoicePath = config.get('submitForInvoicePath');
const submitForInvoice = config.get('submitForInvoice');
const filter = config.get('filter');
const pieceCount = config.get('pieceCount');
const reWeight = config.get('reWeight');
const fileAttachment = config.get('fileAttachment');
const downloadAll = config.get('downloadAll');
const podDetails = config.get('podDetails');
const cs = config.get('cs');
const ops = config.get('ops');
const podFiles = config.get('podFiles');
const download = config.get('download');
const upload = config.get('upload');
const exceptionReason = config.get('exceptionReason');
const podFileExceptionReasons = config.get('podFileExceptionReasons');
const booking = config.get('booking');
const updateManifestProduct = config.get('updateManifestProduct');
const billTypeUpdate = config.get('billTypeUpdate');
const clearOdaCity = config.get('clearOdaCity');
const additionalPickupBarcodes = config.get('additionalPickupBarcodes');
const pickUp = config.get('pickUp');
const delivery = config.get('delivery');
const bulk = config.get('bulk');
const deliveryDateHistory = config.get('deliveryDateHistory');
const deleteDelivery = config.get('deleteDelivery');
const pod = config.get('pod');
const uploadByWaybill = config.get('uploadByWaybill');
const downloadByWaybill = config.get('downloadByWaybill');
const pushToOracle = config.get('pushToOracle');
const holdTerminalException = config.get('holdTerminalException');
const norDelivery = config.get('norDelivery');
const quotation = config.get('quotation');
const subClientId = config.get('subClientId');
const adhocDrivers = config.get('adhocDrivers');
const findEmployeeByPositionId = config.get('findEmployeeByPositionId');
const allEmployee = config.get('allEmployee');
const uploadDeliveredPod = config.get('uploadDeliveredPod');
const findValidAgreementDetail = config.get('findValidAgreementDetail');
const updateFodCod = config.get('updateFodCod');
const uploadMultipleFile = config.get('uploadMultipleFile');

export const getOperationListService = async (filteredData: IFilter) => {
    try {
        return await AjexPortalService.post(`${operation}/${filter}`, filteredData);
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);

        return err?.response;
    }
}

export const getDriverListService = async () => {
    try {
        return await AjexPortalService.get(`${employee}/${position}?${code}=UT003`);
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);

        return err?.response;
    }
}
export const getAdhocDriverListService = async (unAssignDriver = false) => {
    const url = `${employee}/${adhocDrivers}${unAssignDriver ? "?unassigned=true" : ""}`;

    try {
        return await AjexPortalService.get(url);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const getScannedByListService = async (req) => {
    try {
        return await AjexPortalService.post(`${employee}/${findEmployeeByPositionId}?isDriver=false`, req);
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);

        return err?.response;
    }
}

export const getAdhocDriversService = async () => {
    try {
        return await AjexPortalService.get(`${employee}/${adhocDrivers}`);
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);

        return err?.response;
    }
}

export const getAdhocTripsService = async (params?: IAdhocTripsRequest) => {
    const { startDate, endDate, stationId, adhocTripTypeId, requestType, businessId } = params || {};
    let queryStringParams = "";
    if (startDate && endDate) {
        queryStringParams += `?startDate=${startDate.format('YYYY-MM-DD')}&endDate=${endDate.format('YYYY-MM-DD')}`;
    }
    if (stationId) {
        queryStringParams += `&stationId=${stationId}`;
    }
    if (adhocTripTypeId) {
        queryStringParams += `&adhocTripTypeId=${adhocTripTypeId}`
    }
    if (adhocTripTypeId) {
        queryStringParams += `&adhocTripTypeId=${adhocTripTypeId}`
    }
    if (requestType) {
        queryStringParams += `&requestType=${requestType}`
    }
    if (businessId) {
        queryStringParams += `&businessId=${businessId}`
    }

    try {
        return await AjexPortalService.get(`${ADHOC_URL}adhoc-trips/adhoc-vehicle${queryStringParams}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}

export const assignDriverService = async (data: IDriverRequest, options?: { silent?: boolean }) => {
    try {
        return await AjexPortalService.post(`${bookingOperationDetail}/${assign}`, data)
    } catch (error: unknown) {
        const err = error as AxiosError
        // Bulk callers report failures themselves, so they skip the per-request toast
        if (!options?.silent) getNotificationStyle(err?.response);

        return (err?.response);
    }
}
export const AssignDeliveryService = async (data: IDriverRequest) => {
    try {
        return await AjexPortalService.post(`${bookingOperationDetail}/${assignDelivery}`, data)
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);

        return (err?.response);
    }
}

export const OnRTOByIdService = async (id: string) => {
    try {
        return await AjexPortalService.get(`${commonURL}${rto}/${wayBill}/${id}`)
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);

        return (err?.response);
    }
}

export const GetPieceBarCodeService = async (id: number) => {
    try {
        return await AjexPortalService.get(`${commonURL}${pickup}/${getPieceBarCodes}/${id}`)
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);

        return (err?.response);
    }
}

export const UpdateBillTypeService = async (request: IBillTypeUpdate, wayBillNumber?: string) => {
    try {
        return await AjexPortalService.put(`${commonURL}${manifest}/${billTypeUpdate}/${wayBillNumber}`, request)
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);

        return (err?.response);
    }
}
export const ClearOdaCityService = async (request: IClearCity, wayBillNumber: string) => {
    try {
        return await AjexPortalService.put(`${commonURL}${manifest}/${clearOdaCity}/${wayBillNumber}`, request)
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);

        return (err?.response);
    }
}

export const GetBarCodeService = async (id: string) => {
    try {
        return await AjexPortalService.get(`${commonURL}${pickup}/${getBarCodes}/${id}`)
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);

        return (err?.response);
    }
}

export const GetVolumetricService = async (id: number) => {
    try {
        return await AjexPortalService.get(`${commonURL}re-weight/get-volume-metric-weight?bookingId=${id}`)
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);

        return (err?.response);
    }
}

export const ApproveVolumetricService = async (waybillNo: string, remarks: string) => {
    try {
        return await AjexPortalService.patch(
            `${commonURL}re-weight/${waybillNo}/approve?waybillNo=${waybillNo}&remarks=${encodeURIComponent(remarks)}`
        )
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);
        return (err?.response);
    }
}
export const GetVolumetricServiceOld = async (id: number) => {
    try {
        return await AjexPortalService.get(`${commonURL}${scanAtHub}/${getVolumeMetricWeight}/${id}`)
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);
        return (err?.response);
    }
}
export const GetVolumetricByIdService = async (id: number) => {
    try {
        return await AjexPortalService.get(`${commonURL}${reWeight}/${id}`)
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);

        return (err?.response);
    }
}
export const UpdateVolumetricDetailsByIdService = async (id: number, request: Pick<IVolumetric, 'weight' | 'height' | 'length' | 'width' | 'itemCount' | 'pieceLevelTypeId'>) => {
    try {
        return await AjexPortalService.put(`${commonURL}${reWeight}/${id}`, request)
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);

        return (err?.response);
    }
}


export const SearchOperationFilterService = async (filteredData: Partial<IFilter>) => {
    try {
        return await AjexPortalService.post(`${operation}/${filter}`, filteredData);
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);
        return (err?.response)
    }
}

export const AssignPodService = async (data: IPodResponse) => {
    try {
        return await AjexPortalService.post(`${commonURL}${podCollection}`, data)
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);
        return (err?.response);
    }
}

export const GetPodByWaybillService = async (waybillNo?: string) => {
    try {
        return await AjexPortalService.get(`${commonURL}${podCollection}/${wayBill}/${waybillNo}`)
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);
        return (err?.response);
    }
}
export const GetManifestDetailsService = async (waybill: string | undefined) => {
    try {
        return await AjexPortalService.get(`${commonURL}${manifest}?${wayBillNo}=${waybill}`)
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);
        return (err?.response);
    }
}
export const ReCalculateManifestService = async ({ waybillNo, request }: { waybillNo?: string, request?: IReCalculateRequest }) => {
    try {
        return await AjexPortalService.put(`${commonURL}${manifest}/${reCalculate}/${waybillNo}`, request)
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);
        return (err?.response);
    }
}
//https://apps-sit.aj-ex.com/tms-enquiry-quotation-service/api/v1/quotation/98
export const GetQuotationDetailByIdService = async ({ quotationId }: { quotationId?: number }) => {
    try {
        return await AjexPortalService.get(`${ENQUIRY_QUOTATION_URL}${quotation}/${quotationId}`);
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);
        return (err?.response);
    }
}
export const InvoiceManifestService = async (waybillNumber?: string) => {
    try {
        return await AjexPortalService.put(`${commonURL}${manifest}/${submitForInvoicePath}?${wayBillNo}=${waybillNumber}&${submitForInvoice}=true`)
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);
        return (err?.response);
    }
}
export const SaveManifestService = async ({ waybillNo, request }: { waybillNo?: string, request?: Partial<IManifestationRequest> }) => {
    try {
        return await AjexPortalService.put(`${commonURL}${manifest}/${waybillNo}`, request);
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);
        return (err?.response);
    }
}

export const GetReWeightService = async (waybillNumber: string) => {
    try {
        //tms-common-service/api/v1/pickup/piece-count/{wayBillNumber}
        return await AjexPortalService.get(`${commonURL}${pickup}/${pieceCount}/${waybillNumber}`)
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);
        return (err?.response);
    }
}


export const SaveReWeightService = async (body: IReWeight) => {
    try {
        return await AjexPortalService.post(`${commonURL}${reWeight}`, body)
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);
        return (err?.response);
    }
}

export const SaveFleetInformationService = async (body: IFleetManPower) => {
    try {
        return await AjexPortalService.post(`${commonURL}${fleetManPower}/${createFleet}`, body)
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);
        return (err?.response);
    }
}

export const GetFleetInformationService = async (wayBillNumber: string) => {
    try {
        return await AjexPortalService.get(`${commonURL}${fleetManPower}/${wayBill}/${wayBillNumber}`)
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);
        return (err?.response);
    }
}

export const GetOperationFilesListService = async (wayBillNumber: string) => {
    //file-attachment/download-all/A10000010000362
    try {
        return await AjexPortalService.get(`${commonURL}${fileAttachment}/${downloadAll}/${wayBillNumber}`)
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);
        return (err?.response);
    }
}

export const GetOperationProofOfDeliveryBookingListService = async (wayBillNumber: string) => {
    //pod-details/waybill/A10000010000433
    try {
        return await AjexPortalService.get(`${commonURL}${podDetails}/${wayBill}/${wayBillNumber}`)
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);
        return (err?.response);
    }
}


export const SavePodDetailsService = async (data: any, id: number, isOperation: boolean) => {
    //pod-details/waybill/A10000010000433
    try {
        const url = !isOperation ? cs : ops;
        return await AjexPortalService.put(`${commonURL}${podDetails}/${url}/${id}`, data)
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);
        return (err?.response);
    }
}

export const GetPodFilesService = async (id: number) => {
    //pod-files/download/39
    try {
        return await AjexPortalService.get(`${commonURL}${podFiles}/${download}/${id}`)
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);
        return (err?.response);
    }
}

export const UploadPodFilesService = async (id: number, fileObject: Partial<IFileUpload>, isOriginal: boolean) => {
    //pod-files/download/39
    try {
        const { formData, configuration } = UploadPodFileData(fileObject, false, false, { isOriginal })
        return await AjexPortalService.post(`${commonURL}${podFiles}/${upload}/${id}`, formData, configuration)
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);
        return (err?.response);
    }
}

export const UploadPodFileByWaybillService = async (waybill: string | undefined, fileObject: Partial<IFileUpload>, isOriginal: boolean) => {
    //pod-files/download/39
    try {
        const { formData, configuration } = UploadPodFileData(fileObject, false, false, { isOriginal })
        return await AjexPortalService.post(`${commonURL}${podFiles}/${uploadByWaybill}/${waybill}`, formData, configuration)
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);
        return (err?.response);
    }
}

export const DownloadPodFileService = async (id: number) => {
    //pod-files/download-file/105
    try {
        return await AjexPortalService.get(`${commonURL}${podFiles}/${download}/${id}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const DownloadPodFileByWaybillService = async (waybill: string) => {
    //pod-files/download-file/105
    try {
        return await AjexPortalService.get(`${FILE_SERVICE_URL}${podFiles}/${downloadByWaybill}/${waybill}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
export const GetPodFileExceptionsReasonService = async () => {
    //exception-reason/pod-file-exception-reasons
    try {
        return await AjexPortalService.get(`${exceptionReason}/${podFileExceptionReasons}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};


export const GetPODDetailsService = async (airwayBillNumber?: string) => {
    //https://apps-sit.aj-ex.com/tms-booking-service/api/v1/booking/waybill/A1010000634
    try {
        return await AjexPortalService.get(`${booking}/${wayBill}/${airwayBillNumber}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}
export const ManifestUpdateService = async (waybillNumber?: string, request?: Partial<IUpdateManifest>) => {
    //https://apps-sit.aj-ex.com/tms-common-service/api/v1/manifest/update-manifest-product/A1010001137
    try {
        return await AjexPortalService.put(`${commonURL}${manifest}/${updateManifestProduct}/${waybillNumber}`, request);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}
export const SaveAdditionPickupBarcodeService = async (request: IPieceBarcodeRequest) => {
    //https://apps-sit.aj-ex.com/tms-common-service/api/v1/pickup/additional-pickup-barcodes
    try {
        return await AjexPortalService.put(`${commonURL}${pickup}/${additionalPickupBarcodes}`, request);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}
export const UploadFilesService = async (id: number, fileObject: Partial<IFileUpload>) => {
    //pod-files/download/39
    try {
        const { formData, configuration } = UploadPodFileData(fileObject, false, false)
        return await AjexPortalService.post(`${commonURL}${podFiles}/${upload}/${id}`, formData, configuration)
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);
        return (err?.response);
    }
}
export const DownloadBulkPickUpService = async () => {
    //bulk/delivery/download/delivery.xlsx
    try {
        return await AjexPortalService.get(`${commonURL}${bulk}/${pickUp}/${download}/${pickUp}.xlsx`)
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);
        return (err?.response);
    }
}
export const DownloadBulkDeliveryService = async () => {
    //pod-files/download/39
    try {
        return await AjexPortalService.get(`${commonURL}${bulk}/${delivery}/${download}/${delivery}.xlsx`)
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);
        return (err?.response);
    }
}
export const UploadBulkPickUpService = async (request: Partial<IFileUpload>, isBulkPickUp: boolean) => {
    //pod-files/download/39
    try {
        const { formData, configuration } = UploadPodFileData(request, isBulkPickUp, false)
        return await AjexPortalService.post(`${commonURL}${bulk}/${pickUp}`, formData, configuration)
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);
        return (err?.response);
    }
}
export const UploadBulkDeliveryService = async (request: Partial<IFileUpload>, isBulkDelivery: boolean) => {
    //pod-files/download/39
    try {
        const { formData, configuration } = UploadPodFileData(request, false, isBulkDelivery)
        return await AjexPortalService.post(`${commonURL}${bulk}/${delivery}`, formData, configuration)
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);
        return (err?.response);
    }
}
export const ChangeDeliveryDateService = async (request: IChangeDeliveryDate) => {
    //https://apps-sit.aj-ex.com/tms-common-service/api/v1/delivery-date-history
    try {
        return await AjexPortalService.put(`${commonURL}${deliveryDateHistory}`, request);

    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);
        return (err?.response);
    }
}
export const DeleteDeliveryDateService = async (payload) => {
    //https://apps-sit.aj-ex.com/tms-common-service/api/v1/delivery-date-history
    try {
        return await AjexPortalService.put(`${commonURL}${deliveryDateHistory}/${deleteDelivery}/${payload?.waybillNo}`, payload);

    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);
        return (err?.response);
    }
}
export const NORDeliveryService = async (request: Partial<INorDelivery>) => {
    //{{commons}}/api/v1/bulk/nor-delivery
    try {
        return await AjexPortalService.post(`${commonURL}${bulk}/${norDelivery}`, request);

    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);
        return (err?.response);
    }
}

export const getPodOperationListService = async (filteredData: IFilter) => {
    try {
        return await AjexPortalService.post(`${operation}/${pod}/${filter}`, filteredData);
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);

        return err?.response;
    }
}
//{{common-service}}/api/v1/manifest/push-to-oracle/{wayBillNo}
export const PushToOracleService = async (wayBillNo: string | undefined) => {
    try {
        return await AjexPortalService.post(`${commonURL}${manifest}/${pushToOracle}/${wayBillNo}`,);
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);

        return err?.response;
    }
}

//https:/ / apps - sit.aj - ex.com / tms - common - service / api / v1 / hold - terminal - exception / waybill / A1010003198
export const GetHoldAtTerminalService = async (wayBillNo: string | undefined) => {
    try {
        return await AjexPortalService.get(`${commonURL}${holdTerminalException}/${wayBill}/${wayBillNo}`);
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);

        return err?.response;
    }
}

//https://apps-sit.aj-ex.com/tms-common-service/api/v1/hold-terminal-exception
export const AddHoldAtTerminalService = async (request: IAddHoldAtTerminalRequest) => {
    try {
        return await AjexPortalService.post(`${commonURL}${holdTerminalException}`, request);
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);

        return err?.response;
    }
}

//https://apps-sit.aj-ex.com/tms-enquiry-quotation-service/api/v1/quotation/?client_sub_id=53
export const GetQuotationByClientSubIdService = async ({ clientSubId, productId }: { clientSubId?: number, productId?: number }) => {
    try {
        return await AjexPortalService.get(`${ENQUIRY_QUOTATION_URL}${quotation}/?${subClientId}=${clientSubId}&product_id=${productId}`);
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);

        return err?.response;
    }
}
//https://apps-sit.aj-ex.com/tms-manual-waybill-generation-service/api/v1/manual-way-bill/reference/A100078
///manual-way-bill/?way_bill_number=WB-101
export const GetDetailByWaybillService = async (refNumber?: string) => {
    try {
        return await AjexPortalService.get(`${MANUAL_WAYBILL_URL}manual-way-bill/?way_bill_number=${refNumber}`);
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);

        return err?.response;
    }
}
//https://apps-sit.aj-ex.com/tms-common-service/api/v1/manifest/bulk-invoice-confirmed
export const BulkInvoiceService = async (request?: IBulkInvoiceRequest) => {
    try {
        return await AjexPortalService.put(`${commonURL}/manifest/bulk-invoice-confirmed`, request);
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);

        return err?.response;
    }
}

// PUT ${commonURL}/manifest/on-hold
export const BulkHoldManifestService = async (request?: IBulkHoldManifestRequest) => {
    try {
        return await AjexPortalService.put(`${commonURL}/manifest/on-hold`, request);
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);

        return err?.response;
    }
}

// https://apps-sit.aj-ex.com/tms-booking-service/api/v1/employee/all-employee/position?code=UT003
export const getIRSDriverListService = async () => {
    try {
        return await AjexPortalService.get(`${employee}/${allEmployee}/${position}?${code}=UT003`);
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);

        return err?.response;
    }
}

export const MultiUploadPodFileByWaybillService = async (fileObject: RcFile, isOriginal: boolean) => {
    //pod-files/download/39
    try {
        const { formData, configuration } = MultiUploadPodFileData(fileObject, isOriginal)
        return await AjexPortalService.post(`${commonURL}${podFiles}/${uploadDeliveredPod}`, formData, configuration)
    } catch (error: unknown) {
        const err = error as AxiosError
        // getNotificationStyle(err?.response);
        return (err?.response);
    }
}

export const GetValidAgreementDetailService = async (request: IValidAgreementDetailRequest) => {
    try {
        //https://apps-sit.aj-ex.com/tms-booking-service/api/v1//find-valid-agreement-detail
        if (!request.clientId || !request.productId || !request.subProductId || !request.temperatureId) {
            console.error("Invalid request: ", request);
            return;
        }
        return await AjexPortalService.post(`${booking}/${findValidAgreementDetail}`, request)
    } catch (error) {
        const err = error as AxiosError;
        return err?.response
    }
}
export const UpdateFodCodAmountService = async (request: IUpdateCodRequest) => {
    try {
        return await AjexPortalService.put(`${booking}/${updateFodCod}`, request)
    } catch (error) {
        const err = error as AxiosError;
        return err?.response
    }
}

export const UploadCostModuleFileService = async (fileObject: FileUploadRequest) => {
    //pod-files/download/39
    try {
        const { formData, configuration } = MultiUploadCostModuleFileData(fileObject)
        return await AjexPortalService.post(`${commonURL}file-attachment/upload-multiple-file`, formData, configuration)
    } catch (error: unknown) {
        const err = error as AxiosError
        // getNotificationStyle(err?.response);
        return (err?.response);
    }
}

export const GetCostModuleFileByBookingIDService = async (id: string) => {
    //pod-files/download/39
    try {
        return await AjexPortalService.get(`${commonURL}file-attachment/download-by-category-id?category-id=${id}&category=Adhoc Vehicle Invoice Document&fileType=Adhoc Vehicle Invoice Document`)
    } catch (error: unknown) {
        const err = error as AxiosError
        // getNotificationStyle(err?.response);
        return (err?.response);
    }
}

export const DownloadCostModuleFileByBookingIDService = async (id: number) => {
    //pod-files/download/39
    try {
        return await AjexPortalService.get(`${commonURL}file-attachment/download-single-file/${id}`)
    } catch (error: unknown) {
        const err = error as AxiosError
        // getNotificationStyle(err?.response);
        return (err?.response);
    }
}

export const DeleteCostModuleFileByIDService = async (id: string) => {
    // https://apps-sit.aj-ex.com/tms-common-service/api/v1/file-attachment/delete-file/{id}
    try {
        return await AjexPortalService.delete(`${commonURL}file-attachment/delete-file/${id}`)
    } catch (error: unknown) {
        const err = error as AxiosError
        // getNotificationStyle(err?.response);
        return (err?.response);
    }
}

export const PickupCancelRequestService = async (data) => {
    try {
        const formData = new FormData();
        formData.append('waybillNo', data?.waybillNo);
        formData.append('bookingId', data?.bookingId);
        formData.append('exceptionId', data?.exceptionId);
        formData.append('remarks', data?.remarks);
        formData.append('fromSource', data?.fromSource);
        formData.append('category', data?.category);
        data?.fileType && formData.append('fileType', data?.fileType);
        data?.file && formData.append('files', data?.file);
        data?.fileFormat && formData.append('fileFormat', data?.fileFormat);
        return await AjexPortalService.post(`${commonURL}cancel-pickup`, formData, configuration);
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);
        return (err?.response);
    }
}


export const UploadAdditionalFileService = async (waybill: string | undefined, fileObject: Partial<IFileUpload>) => {
    //pod-files/download/39
    try {
        const { formData, configuration } = UploadCnDnFileData(fileObject)
        return await AjexPortalService.post(`${commonURL}${fileAttachment}/${uploadMultipleFile}`, formData, configuration);
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);
        return (err?.response);
    }
}

export const BulkPushToOracleInvoiceService = async () => {
    try {
        return await AjexPortalService.get(`${commonURL}manifest/push-to-oracle/bulk`);
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);
        return err?.response;
    }
}

export const GetCustomerVolumetricService = async (waybillNo: string) => {
    try {
        return await AjexPortalService.get(`${commonURL}customer-volumetric?waybillNo=${waybillNo}`);
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);
        return (err?.response);
    }
}